<ng-container *ngIf="status; else emptyState">
  <app-badge [text]="'order-status.' + status | translate | uppercase" [backgroundColor]="OrderStatus.color(status)">
  </app-badge>
</ng-container>
<ng-template #emptyState> - </ng-template>
